import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import workerImage from './assets/worker-transparent-v2.png';

type Lang = 'en' | 'ur';

const defaultMessages = {
  en: ['Munshi-Gee is working on it…', 'Checking the details carefully…', 'Your result is being prepared…'],
  ur: ['منشی جی آپ کی معلومات دیکھ رہا ہے…', 'تفصیلات کا احتیاط سے جائزہ لیا جا رہا ہے…', 'آپ کا نتیجہ تیار کیا جا رہا ہے…'],
};

export function ProcessingOverlay({open,lang,messages}:{open:boolean;lang:Lang;messages?:string[]}) {
  const list=messages?.length?messages:defaultMessages[lang];
  const [index,setIndex]=useState(0);
  useEffect(()=>{setIndex(0);if(!open||list.length<2)return;const timer=window.setInterval(()=>setIndex(value=>(value+1)%list.length),2600);return()=>window.clearInterval(timer);},[open,list.join('|')]);
  useEffect(()=>{if(!open)return;const previous=document.body.style.overflow;document.body.style.overflow='hidden';return()=>{document.body.style.overflow=previous;};},[open]);
  if(!open)return null;
  return createPortal(<div className="processing-overlay" role="status" aria-live="polite" aria-busy="true" dir={lang==='ur'?'rtl':'ltr'}>
    <div className="processing-card">
      <div className="processing-worker"><span></span><img src={workerImage} alt=""/></div>
      <div className="processing-heading"><small>Munshi-Gee</small><h2>{lang==='ur'?'منشی جی آپ کے لیے کام کر رہا ہے':'Munshi-Gee is working for you'}</h2></div>
      <div className="processing-copy" key={index}><b>{list[index]}</b><small>{lang==='ur'?'براہِ کرم یہ صفحہ بند نہ کریں':'Please keep this page open'}</small></div>
      <div className="processing-progress"><i></i></div>
    </div>
  </div>,document.body);
}
